import React from "react";

import SignContractPage from "@/pages/sign-contract";
import InitApp from "../pages/initApp";
import Login from "../pages/Login";
import Logout from "../pages/Logout";
import OAuthCallback from "../pages/OAuthCallbackPage";

interface RouteDef {
  component: React.ComponentType<any>;
  path: string;
  protected: boolean;
  exact: boolean;
}

type ROUTESType<Names extends string> = Record<Names, RouteDef>;

type InitRoutesNames = "login" | "logout" | "initApp" | "oAuthCallback" | "signContract";

/* eslint-disable sort-keys */
export const INIT_ROUTES: ROUTESType<InitRoutesNames> = {
  signContract: { component: SignContractPage, exact: true, path: "/sign-contract", protected: false },
  login: { component: Login, exact: true, path: "/login", protected: false },
  logout: { component: Logout, exact: true, path: "/logout", protected: false },
  // this path should be placed before initApp to send user to oAuthCallback, because initApp path is not exact
  oAuthCallback: { component: OAuthCallback, exact: true, path: "/oauth_callback", protected: false },
  // this path should not be EXACT, because if it is, then sub Switch is never reached
  initApp: { component: InitApp, exact: false, path: "/*", protected: false },
};
